import { render, staticRenderFns } from "./CarThumb.vue?vue&type=template&id=489ef850&scoped=true&"
import script from "./CarThumb.vue?vue&type=script&lang=js&"
export * from "./CarThumb.vue?vue&type=script&lang=js&"
import style0 from "./CarThumb.vue?vue&type=style&index=0&id=489ef850&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ef850",
  null
  
)

export default component.exports